import PaginatedList from '@theme/paginated-list';
import { initBlogPostCardZoom } from '@theme/blog-post-card-zoom';

/**
 * Paginated blog posts list. Card image zoom uses the shared helper.
 */
export default class BlogPostsList extends PaginatedList {
  /** @type {{ destroy: () => void } | null} */
  #zoom = null;

  connectedCallback() {
    super.connectedCallback();
    requestAnimationFrame(() => {
      this.#zoom?.destroy();
      this.#zoom = initBlogPostCardZoom(this);
    });
  }

  disconnectedCallback() {
    this.#zoom?.destroy();
    this.#zoom = null;
    super.disconnectedCallback?.();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
